import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Parser from "html-react-parser";
import PropTypes from "prop-types";
import CardTypeFolder from "@components/CardTypeFolder/CardTypeFolder";
import * as InterconexonActions from "app/@Base/store/actions";
import useMediaQuery from "app/hooks/useMediaQuery";

const BORDER_TOP_COLOR = "#d7de00";
const ROOT = process.env.REACT_APP_CMS_STATIC;

const Delegado = ({ delegado, ...props }) => {
  const dispatch = useDispatch();
  const [detailTitleStyle, setDetailTitleStyle] = useState({ width: "235px" });
  const [delegate] = useState(delegado);

  const is4K = useMediaQuery("(min-width: 3840px)");
  const isFullHD = useMediaQuery("(min-width: 1920px)");
  const isMidLaptop = useMediaQuery("(min-width: 1366px)");
  const isIpadLandscape = useMediaQuery("(min-width: 1024px)");
  const isIpadPortrait = useMediaQuery("(min-width: 768px)");
  const isIphoneX = useMediaQuery("(min-width: 375px)");
  const isXSmall = useMediaQuery("(max-width: 374px)");

  const getWidthTitle = () => {
    if (isXSmall || isIphoneX) {
      setDetailTitleStyle({ width: "175px" });
    }
    if (isIpadPortrait || isIpadLandscape || isMidLaptop || isFullHD || is4K) {
      setDetailTitleStyle({ width: "235px" });
    }
  };

  useEffect(() => {
    return () => {
      dispatch(InterconexonActions.resetDelegado());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getWidthTitle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    is4K,
    isFullHD,
    isMidLaptop,
    isIpadLandscape,
    isIpadPortrait,
    isIphoneX,
    isXSmall,
  ]);

  return (
    <>
      <div className="investment-container">
        <div className="w-100 d-flex flex-column align-items-start text-left">
          <h1 className="investment-title">{delegate.title}</h1>
          <span className="investment-description">
            {Parser(delegate.description)}
          </span>
        </div>
        <div className="w-100">
          {delegate.files && delegate.files.length > 0 && (
            <CardTypeFolder
              titleStyle={detailTitleStyle}
              title="Documentos"
              description=""
              files={
                delegate.files &&
                delegate.files.map((file) => {
                  return {
                    fileName: file.tituloEnlace,
                    fileURL: ROOT + file.archivo.urls[0],
                  };
                })
              }
              borderTopColor={BORDER_TOP_COLOR}
            />
          )}
        </div>
      </div>
    </>
  );
};

Delegado.propTypes = {
  delegado: PropTypes.object.isRequired,
};

export default Delegado;
